import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { getMyOrganizations } from '@/services/asociaciones'

export const useOrgAdminStore = defineStore('orgAdmin', () => {
  const organizations = ref([])
  const checked = ref(false)

  const isOrgAdmin = computed(() => organizations.value.length > 0)

  async function ensureChecked() {
    if (checked.value) return isOrgAdmin.value
    try {
      organizations.value = await getMyOrganizations()
    } catch {
      organizations.value = []
    }
    checked.value = true
    return isOrgAdmin.value
  }

  function reset() {
    organizations.value = []
    checked.value = false
  }

  return { organizations, isOrgAdmin, ensureChecked, reset }
})
